export default {
      id: "LWS-6px-usage",
      viewBox: "0 0 60 6",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-6px",
      toString: function () {
        return this.url;
      }
    }